module.exports = __webpack_public_path__ + "static/media/bff2.7baab1c3.png";